/* eslint-disable no-unreachable */
import React, { useEffect } from 'react'

import { Button, Typography } from '../../../components'

import dna from '../../../assets/Icons/dnaIcon.svg'

import * as S from '../styles'
import useActions from '../../../hooks/useActions'
import { signUpActions } from '../../../redux/ducks/signUp'
import { useSelector } from 'react-redux'
import ErrorMessage from '../../../components/Form/ErrorMessage'
import useScrollToTop from '../../../hooks/useScrollToTop'
import { formatCentsToReal } from '../../../helpers/formatCentsToReal'

const StepThree = () => {
  const { setStep3, nextStep, prevStep, fetchProducts, setError } =
    useActions(signUpActions)
  const { step3, error } = useSelector((state) => state.signUp)
  const { products, productSelected } = step3
  const { scrollToTop } = useScrollToTop()

  useEffect(() => {
    scrollToTop()
  }, [scrollToTop])

  useEffect(() => {
    fetchProducts()
  }, [fetchProducts])

  const onSubmit = () => {
    if (!productSelected) {
      setError('Selecione um produto')
      return
    }

    nextStep()
  }

  const selectProduct = (product) => {
    setStep3({
      ...step3,
      productSelected: product
    })
  }

  return (
    <S.StepContainer>
      <Typography
        type="text"
        color="#7D7987"
        spacing="0 0 1.5rem 0"
        align="center"
      >
        Escolha a certificação que deseja
      </Typography>
      {!products?.length ? (
        <S.InputContainer>
          <ErrorMessage>
            Nenhum produto cadastrado. Entre em contato com o suporte.
          </ErrorMessage>
        </S.InputContainer>
      ) : (
        <>
          <S.InputContainer wrap>
            {products?.map?.((product) => (
              <S.PlanCard
                key={product.id}
                selected={product.id === productSelected?.id}
                onClick={() => selectProduct(product)}
              >
                <img src={dna} alt="Produto" />
                <Typography
                  type="label"
                  color="#858585"
                  weight={700}
                  spacing="12px 0 0"
                >
                  {product.name}
                </Typography>
                <S.PriceContainer>
                  <Typography type="subTitle" color="#BE9137" spacing="5px 0">
                    {product.amount && formatCentsToReal(product.amount)}
                  </Typography>
                  {product.maxInstallments > 1 && (
                    <div>
                      <Typography type="label" color="#858585" display="inline">
                        em até <strong>{product.maxInstallments}x</strong> de{' '}
                      </Typography>
                      <Typography type="label" color="#858585" display="inline">
                        <strong>
                          {formatCentsToReal(
                            product.amount / product.maxInstallments
                          )}
                        </strong>
                      </Typography>
                    </div>
                  )}
                </S.PriceContainer>
              </S.PlanCard>
            ))}
          </S.InputContainer>
          <S.InputContainer>
            <ErrorMessage>{error}</ErrorMessage>
          </S.InputContainer>
        </>
      )}
      <S.ButtonContainer>
        <Button
          text="VOLTAR"
          type="button"
          variant="outlined"
          width="200px"
          onClick={prevStep}
        />
        <Button
          text="PROSSEGUIR"
          type="button"
          variant="primary"
          width="200px"
          onClick={onSubmit}
          disabled={!productSelected}
        />
      </S.ButtonContainer>
    </S.StepContainer>
  )
}

export default StepThree
